import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Concept, getSelectedConcept } from '../../redux/ConceptSlice';
import { getSelectedUnderlyingConcept } from '../../redux/TaxonomyConceptSlice';
import enums from '../../utils/enums';
import ToastReporter from './ToastReporter';


const ConceptReporter = (props: any) => {
    //TODO create a generic reporter component to actually render the topic and details.
    //props should include title and detail list
    const dispatch = useAppDispatch();
    var location = useLocation();
    var concept: Concept | null = (location.pathname.indexOf("/AccountCodeManagement") >= 0) ? useAppSelector(getSelectedUnderlyingConcept) : useAppSelector(getSelectedConcept);
    var dtype: string = "none";
    if (concept && concept.datatype) {
        dtype = enums.conceptDatatype[concept.datatype]; 
    }
    var detaildata = concept ? [
        { key: "Name", value: concept.name },
        { key: "Code", value: concept.code },
        { key: "Doc", value: concept.documentation },
        { key: "Data Type", value: dtype }
    ] : [];

    if (concept) {
        if (concept.domainDatatype === "NONE" ) {
            dtype = (enums.conceptDatatype as any)[concept.datatype];
        } else {
            dtype = (enums.conceptDatatype as any)[concept.domainDatatype];
        }
        var rank = 0;
        if (concept.references) {
            for (var cref of concept.references) {
                if (cref.type.indexOf("accountDependency") >= 0) {
                    continue;
                }
                var pkey: string = "R" + rank;

                var parts: any[] = cref.parts;
                var isDew: boolean = false;
                if(cref.type.indexOf("/dew") > 0 ) {
                    pkey = "";
                    isDew = true;
                    parts = cref.parts.filter(function (part) {
                        var accept: boolean = false;
                        switch (part.definition.name) {
                            case "DEWAccount":
                            case "DEWCalculation":
                            case "DEWSource":
                                accept = true;
                                break;
                        }
                        return accept;
                    });
                    parts.sort((a, b) => (a.definition.name < b.definition.name) ? 1 : ((a.definition.name > b.definition.name) ? -1 : 0));
                }
                var partValues = "";
                rank++;
                for (var part of parts) {
                    switch (part.definition.name) {
                        case "Name":
                            if (!isDew) {
                                pkey = part.value;
                            }
                            break;

                        case "UASID":
                        case "IssueDate":
                            break;

                        default:
//                            var pkey: string = "R" + rank + " " + part.definition.name;
                            //                            detaildata.push({ key: pkey, value: part.value });
                            if (partValues.length > 0) {
                                partValues += "<br>";
                            }
                            partValues += part.definition.name + ": " + part.value;
                            break;
                    }
                }
                detaildata.push({ key: pkey, value: partValues });
            }
        }
    }

    const title = function () {
        if (location.pathname.indexOf("/AccountCodeManagement") >= 0) {
            return "Current Taxonomy Concept";
        }
        var titleTopic = "Current Account";
        if (concept && concept.code) {
            if (concept.code.length <= 3) {
                titleTopic = "Current Fund"
            }
        }
        return titleTopic;
    }

    return (
        <div>
            { concept != null ?
                <ToastReporter topic={title()} style="currentAccount" details={detaildata} showReadMoreMaxChars={140} />
                : (<div></div>)
            }
        </div>
    )
}

export default ConceptReporter;